var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'image')?_c('ImageZoom',{attrs:{"src":_vm.src,"height":_vm.height}}):(_vm.type === 'pdf')?_c('iframe',{style:({ minHeight: _vm.height }),attrs:{"src":_vm.src,"height":_vm.height,"width":"100%"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }